import { Slot } from '@radix-ui/react-slot'
import type { ComponentProps } from 'react'

import { cn } from '@/lib/utils'

export type DropzoneProps = ComponentProps<'div'> & {
  active?: boolean
  asChild?: boolean
  disabled?: boolean
}

function Dropzone({
  active = false,
  asChild = false,
  disabled = false,
  className,
  ...props
}: DropzoneProps) {
  const Component = asChild ? Slot : 'div'

  return (
    <Component
      data-slot="dropzone"
      data-state={active ? 'active' : 'idle'}
      aria-disabled={disabled || undefined}
      className={cn(
        'rounded-xl border border-dashed border-input bg-elevated text-foreground outline-none transition-[background-color,border-color,box-shadow,color]',
        'hover:border-selection-border hover:bg-accentSecondary/30',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        active && 'border-selection-border bg-accentSecondary/50',
        disabled &&
          'pointer-events-none cursor-not-allowed border-border bg-muted text-muted-foreground opacity-65',
        className
      )}
      {...props}
    />
  )
}

export { Dropzone }
